export type GrantAccess = "owner" | "write" | "read";

const canWriteGrant = (access: GrantAccess | null | undefined): boolean =>
  access === "owner" || access === "write";

const isOwnedGrant = (access: GrantAccess | null | undefined): boolean =>
  access === "owner";

export const canOpenGrant = (access: GrantAccess | null | undefined): boolean =>
  access === "owner" || access === "write" || access === "read";

type KitArtifactAccess = {
  readonly?: boolean;
  access?: GrantAccess | null;
};

/** The kit's own artifact: not a link, and the caller holds the owner grant. */
export const isOwnedArtifact = (artifact: KitArtifactAccess): boolean =>
  artifact.readonly === false && isOwnedGrant(artifact.access);

/** Editable inside the kit: not a link, and the caller can write. */
export const canWriteArtifact = (artifact: KitArtifactAccess): boolean =>
  artifact.readonly === false && canWriteGrant(artifact.access);
